export default __webpack_public_path__ + "media/images/rank_01-7904b1e2e0fbcaf5ab5229f2210631aa.png";